module.exports = __webpack_public_path__ + "img/scene4-7.37e04f03.jpg";